export const TITLE = 'MicrosoftTeams';
export const COLOR_PRIMARY = '#fff';
